
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { BusinessUnitId_$reflection } from "./Shared.js";
import { record_type, option_type, bool_type, class_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { bind, map } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { choose, map as map_1, tryFind } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { equals } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export class BusinessUnit extends Record {
    constructor(Id, Name, Description, CreatedAt, UpdatedAt, IsDeleted, ParentId, ImageUrl) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.CreatedAt = CreatedAt;
        this.UpdatedAt = UpdatedAt;
        this.IsDeleted = IsDeleted;
        this.ParentId = ParentId;
        this.ImageUrl = ImageUrl;
    }
}

export function BusinessUnit_$reflection() {
    return record_type("Shared.BusinessUnit.BusinessUnit", [], BusinessUnit, () => [["Id", BusinessUnitId_$reflection()], ["Name", string_type], ["Description", string_type], ["CreatedAt", class_type("System.DateTime")], ["UpdatedAt", class_type("System.DateTime")], ["IsDeleted", bool_type], ["ParentId", option_type(BusinessUnitId_$reflection())], ["ImageUrl", option_type(string_type)]]);
}

export class BusinessUnitOverviewDto extends Record {
    constructor(Id, Name, Description, ParentId) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.ParentId = ParentId;
    }
}

export function BusinessUnitOverviewDto_$reflection() {
    return record_type("Shared.BusinessUnit.BusinessUnitOverviewDto", [], BusinessUnitOverviewDto, () => [["Id", string_type], ["Name", string_type], ["Description", string_type], ["ParentId", option_type(string_type)]]);
}

export class BusinessUnitDetailDto extends Record {
    constructor(Id, Name, Description, ParentId, ParentBusinessUnitName, ImageUrl) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Description = Description;
        this.ParentId = ParentId;
        this.ParentBusinessUnitName = ParentBusinessUnitName;
        this.ImageUrl = ImageUrl;
    }
}

export function BusinessUnitDetailDto_$reflection() {
    return record_type("Shared.BusinessUnit.BusinessUnitDetailDto", [], BusinessUnitDetailDto, () => [["Id", string_type], ["Name", string_type], ["Description", string_type], ["ParentId", option_type(string_type)], ["ParentBusinessUnitName", option_type(string_type)], ["ImageUrl", option_type(string_type)]]);
}

export class BusinessUnitCreateDto extends Record {
    constructor(Name, Description, ParentId) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.ParentId = ParentId;
    }
}

export function BusinessUnitCreateDto_$reflection() {
    return record_type("Shared.BusinessUnit.BusinessUnitCreateDto", [], BusinessUnitCreateDto, () => [["Name", string_type], ["Description", string_type], ["ParentId", option_type(string_type)]]);
}

export class BusinessUnitUpdateDto extends Record {
    constructor(Name, Description, ParentId, ImageUrl) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.ParentId = ParentId;
        this.ImageUrl = ImageUrl;
    }
}

export function BusinessUnitUpdateDto_$reflection() {
    return record_type("Shared.BusinessUnit.BusinessUnitUpdateDto", [], BusinessUnitUpdateDto, () => [["Name", string_type], ["Description", string_type], ["ParentId", option_type(string_type)], ["ImageUrl", option_type(string_type)]]);
}

export class UpdateAssignedBusinessUnitDto extends Record {
    constructor(BusinessUnitId, StorageId) {
        super();
        this.BusinessUnitId = BusinessUnitId;
        this.StorageId = StorageId;
    }
}

export function UpdateAssignedBusinessUnitDto_$reflection() {
    return record_type("Shared.BusinessUnit.UpdateAssignedBusinessUnitDto", [], UpdateAssignedBusinessUnitDto, () => [["BusinessUnitId", option_type(string_type)], ["StorageId", string_type]]);
}

export function Helper_getBusinessUnitName(businessUnitId, businessUnits) {
    return map((_arg) => _arg.Name, bind((businessUnitId_1) => tryFind((businessUnit) => equals(businessUnit.Id, businessUnitId_1), businessUnits), businessUnitId));
}

export function Helper_getBusinessUnitNames(businessUnitIds, businessUnits) {
    return map_1((_arg) => _arg.Name, choose((businessUnitId) => tryFind((businessUnit) => equals(businessUnit.Id, businessUnitId), businessUnits), businessUnitIds));
}

